import type { RuleHandler } from "../types";
import { setIncludes } from "../setIncludes";

const checkAllMeetingIdsMustMatch: RuleHandler = (context, requirement) => {
  const requirementAttributes = requirement.userDrivenAttributes;

  if (
    !setIncludes(
      new Set(requirementAttributes?.meetingIds),
      new Set(context.selection.meetingIds),
      requirementAttributes?.allMeetingIdsMustMatch || false,
    )
  ) {
    return false;
  }

  return true;
};

export { checkAllMeetingIdsMustMatch };
